/* eslint-disable react/no-unknown-property */
import React, { FunctionComponent, PropsWithChildren } from 'react';

import * as styles from './GenericPageLayoutWrapper.style';

export enum GenericPageLayoutWrapperSize {
  SMALL = '40rem',
  MEDIUM = '60rem',
  LARGE = '75rem',
  XLARGE = '86rem',
  FULL = '100%',
}

export type GenericPageLayoutWrapperProps = PropsWithChildren<{
  maxWidth?: GenericPageLayoutWrapperSize,
  fitMaxAvailableHeight?: boolean,
}>;

const GenericPageLayoutWrapper: FunctionComponent<GenericPageLayoutWrapperProps> = ({
  maxWidth,
  fitMaxAvailableHeight,
  children,
}) => (
  <div
    css={styles.wrapper}
    width={maxWidth || GenericPageLayoutWrapperSize.XLARGE}
    $fitMaxAvailableHeight={fitMaxAvailableHeight}
  >
    {children}
  </div>
);

export default GenericPageLayoutWrapper;
